export enum NotificationTypeEnum {
  TIPS = 'tips',
  SERVICES = 'services',
  CHAT = 'chat',
}
